import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { StatusBadge } from "./StatusBadge";
import { mediaUrl } from "../lib/api";
import { ease } from "../lib/content";

export const BentoTile = ({ product, className = "", large = false, index = 0 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease, delay: index * 0.08 }}
  >
    <Link to={`/products/${product?.slug}`} data-testid={`bento-product-${index}`} className="group relative block h-full overflow-hidden bg-teal-deep">
      {product?.image && (
        <img src={mediaUrl(product.image)} alt={product?.name} className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-[1.07]" />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-teal-ink/90 via-teal-ink/25 to-transparent" />
      <div className="absolute left-5 top-5">
        <StatusBadge status={product?.status} />
      </div>
      <span className="absolute right-5 top-5 flex h-11 w-11 items-center justify-center rounded-full bg-mist/90 text-teal opacity-0 transition-[opacity,transform] duration-500 group-hover:rotate-45 group-hover:opacity-100">
        <ArrowUpRight className="h-4 w-4" />
      </span>
      <div className="absolute inset-x-0 bottom-0 p-6 text-mist">
        <p className="font-mono text-[11px] uppercase tracking-[0.16em] text-mist/80">{product?.category}</p>
        <h3 className={`mt-2 font-display font-normal leading-tight tracking-tight ${large ? "text-3xl sm:text-5xl" : "text-2xl"}`}>{product?.name}</h3>
        {large && product?.summary && <p className="mt-3 max-w-md text-sm leading-relaxed text-mist/85">{product.summary}</p>}
      </div>
    </Link>
  </motion.div>
);
